import { useFormikContext } from 'formik';
import { Input, Layout, Permission, Select } from 'Components';
import { useTranslation } from 'react-i18next';
import {
	DynamicPermissionCode,
	PermissionCode
} from 'Services/Api/Users/Types';
import { LanguageI18nKey } from 'Services/Api/Common/Types';
import { TITLE_BY_MENU_KEY } from 'i18n/i18n.constants';
import {
	RoleField,
	GroupField
} from '../components';
import UserContextProvider, { UserContext } from '../UserContext';
import { AddUserValues } from '../User.types';
function CreateUserFormFields() {
	const { t } = useTranslation();
	const { values } = useFormikContext<AddUserValues>();
	return (
		<UserContextProvider permissionCode={DynamicPermissionCode.AddUser}>
			<Layout.List>
				<Layout.List.ListItem title={t('user.editUser.tabs.profile')}>
					<Layout.List.Section title={t('general')}>
						<Input.FormikField
							name="firstName"
							label={t('user.firstName')}
							required
						/>
						<Input.FormikField
							name="lastName"
							label={t('user.lastName')}
							required
						/>
						<Input.FormikField
							name="email"
							label={t('user.email')}
							required
						/>
						<Input.FormikField
							name="cognitoLogin"
							label={t('user.cognitoLogin')}
							required
						/>
						<Input.FormikField
							name="phoneNumber"
							label={t('user.phoneNumber')}
						/>
					</Layout.List.Section>
					<Layout.List.Section title={t('user.permission')}>
						<RoleField />
						<GroupField />
					</Layout.List.Section>
				</Layout.List.ListItem>
				<Layout.List.ListItem title={t('user.accountsSettings')}>
					<Layout.List.Section>
						<UserContext.Consumer>
							{({
								languages,
								languagesList,
								timezones,
								timezonesList
							}) => (
								<>
									<Select.FormikField
										name="timezoneId"
										label={t('user.timezoneId')}
										loading={timezones.loading}
									>
										{timezonesList?.map((option) => (
											<Select.Option
												key={option.id}
												value={option.id}
											>
												{option.zone}
											</Select.Option>
										))}
									</Select.FormikField>
									<Select.FormikField
										name="languageId"
										label={t('user.languageId')}
										loading={languages.loading}
									>
										{languagesList?.filter(lang => lang.name === TITLE_BY_MENU_KEY[LanguageI18nKey.English])?.map((option) => (
											// @NOTE: 'disabled' implemented according to https://support.dataart.com/browse/VNZ-1931
											<Select.Option
												key={option.id}
												value={option.id}
												disabled={
													option.name !==
													TITLE_BY_MENU_KEY[
														LanguageI18nKey.English
													]
												}
											>
												{option.name}
											</Select.Option>
										))}
									</Select.FormikField>
								</>
							)}
						</UserContext.Consumer>
					</Layout.List.Section>
				</Layout.List.ListItem>
			</Layout.List>
		</UserContextProvider>
	);
}

export default CreateUserFormFields;
